import { ContentPlaceholder } from 'components/ContentPlaceholder'
import { GlobalSettingsContext } from 'context/GlobalSettingsContext'
import { GlobalSettingType } from 'model'
import * as React from 'react'
import { useRoute } from 'react-router5'
import { getRoute } from 'router'
import routes from 'routes'
import { useGlobalSettingsQuery } from './routeComponent.generated'

export const RouteComponent: React.FunctionComponent = (props) => {
  const { route: routeState } = useRoute()
  const route = getRoute(routes, routeState.name)
  const Component = route ? route.component : undefined

  const { data, loading } = useGlobalSettingsQuery()
  const globalSettings = data && data.globalSettings ? data.globalSettings : []
  const settingsFn = React.useCallback(
    (type: GlobalSettingType) => {
      return globalSettings.find((s) => s.type === type)
    },
    [globalSettings]
  )

  return Component ? (
    loading ? (
      <></>
    ) : (
      <GlobalSettingsContext.Provider
        value={{ getSetting: settingsFn, allSettings: globalSettings }}
      >
        <Component route={route} {...props} />
      </GlobalSettingsContext.Provider>
    )
  ) : (
    <ContentPlaceholder>
      <pre>
        {`Route Placeholder: ${JSON.stringify(
          { name: routeState.name, path: routeState.path },
          null,
          2
        )}`}
      </pre>
    </ContentPlaceholder>
  )
}

export default RouteComponent
